import S from "./Assessments.module.scss";

/** Topic list (proficiencies or growth opportunities) */
const TopicList = ({ heading, topics, variant }) => {
  if (!topics.length) return null;
  const iconClass = variant === "growth" ? S.topicIconWarning : S.topicIconCheck;
  const iconSymbol = variant === "growth" ? "⚠" : "✓";

  return (
    <div className={S.topicListColumn}>
      <span className={S.topicListHeading}>{heading}</span>
      {topics.map(t => (
        <div key={t.fullPath} className={S.topicItem}>
          <span className={iconClass}>{iconSymbol}</span>
          <span>{t.pathTitle ?? t.fullPath}</span>
        </div>
      ))}
    </div>
  );
};

export { TopicList };
